import React from 'react';
import Mascot from './Mascot';

/**
 * Shared header layout for the app's top-level category panels (Select
 * Mission / Quick Start / Manage My Exercises / Previously... / Shop): a
 * mascot portrait sits beside the panel's title. Full-width body content
 * (`children`) always renders below it.
 * [2026-08-18] These panels used to be individually collapsible sections
 * stacked on one scrolling page (tap the header to expand/collapse); the
 * whole app is now tab-based instead -- exactly one panel is on screen at a
 * time, chosen via TabBar, so there's nothing left to collapse. The header
 * row went from a clickable toggle <button> back to a plain, static <div>;
 * the ▸/▾ chevron is gone since there's no longer an open/closed state to
 * indicate. `open`/`onToggle` props were removed entirely -- every caller
 * that used to gate its own children on `open` now renders them
 * unconditionally, since CategoryPanel itself is only ever mounted while
 * its owning tab is the active one (or, for panels living inside a
 * multi-tab component like WorkoutLog.jsx, wrapped in a display:none/block
 * div driven by the shared `activeTab` state one level up).
 * `outerClassName` carries the panel's box-model/border classes, e.g.
 * "comic-panel--category comic-panel--border-peach" -- see comic.css for
 * the shared box model (comic-panel--category) and the color modifiers
 * layered on top of it (comic-panel--border-peach / --border-green).
 */
const CategoryPanel = ({ mascotVariant, outerClassName, title, children }) => (
  <div className={`comic-panel ${outerClassName} comic-panel--with-mascot`}>
    <div className="comic-panel__header-row">
      <Mascot variant={mascotVariant} />
      <div className="comic-panel__header-content">
        <h2 className="comic-title" style={{ fontSize: "24px", margin: 0 }}>{title}</h2>
      </div>
    </div>
    {children && <div className="comic-panel__body">{children}</div>}
  </div>
);

export default CategoryPanel;
